module.exports = __webpack_public_path__ + "img/team.cd2b2ee5.png";